/// <amd-module name="Wit/Settings/BoardsExternalIntegration/contracts/Models" />
import { IPivotBarAction } from "VSSUI/PivotBar";

export interface IPivotProps {
    updateHubCommands(commands: IPivotBarAction[]): void;
}

export type GitHubOAuthState = { [key: string]: string };

export interface UserAuthorization {
    scheme: string;
    gitHubHandle: string;
    avatarUrl: string;
    token?: string;
    configurationId?: string;
    username?: string;
    password?: string;
}

export interface AuthData {
    token?: string;
    username?: string;
    password?: string;
}

export interface IBacklogLevelConfiguration {
    defaultWorkItemType: string;
    id: string;
}

export interface ITeam {
    id: string;
    name: string;
}

export interface IBoardContentHeaderData {
    allBacklogLevels: IBacklogLevelConfiguration[];
    backlogId: string;
    team: ITeam;
}

export interface ITeamWITSettings {
    teamFieldDefaultValue: string;
    teamFieldName: string;
}
